import { call, put, takeLatest } from 'redux-saga/effects'
import { getVehicles } from '../../firebase-services/db-services';
import { getVehiclesSuccess } from '../slices/vehicleState';
function* async_getVehicleFetch() {
        
        const vehicles = yield call(()=>getVehicles());
        const formattedVehicles = yield vehicles.docs;
        //console.log({filter,Party})
        const vehicleData = formattedVehicles.map(doc =>{
            return {...doc.data(),docid:doc.id}
        } )
        yield put(getVehiclesSuccess(vehicleData))
        
}
function* vehicleSaga() {
    yield takeLatest('vehicles/getVehiclesFetch', async_getVehicleFetch);
}
export default vehicleSaga;